module.exports = __webpack_public_path__ + "img/img_pic@2x.df4065a8.png";